<template>
  <div
    :class="`wrapper-container tw-flex tw-flex-col tw-items-center tw-gap-[40px] tw-pt-[80px] tw-pb-[40px] tw-px-[40px] ${
      overflowVisibleComponents.includes(activeComponent)
        ? 'md:!tw-overflow-visible'
        : ''
    }`"
  >
    <div
      class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[7px]"
    >
      <span
        class="tw-text-center tw-text-[#211F58] tw-text-[22px] tw-font-semibold"
        >{{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-modal-wrapper-title-1",
          )
        }}</span
      >
      <span
        class="tw-text-center tw-text-[#878787] tw-text-[15px] tw-font-normal"
        >{{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-modal-wrapper-sub-title-1",
          )
        }}</span
      >
    </div>
    <div
      :class="`body-container tw-relative ${
        overflowVisibleComponents.includes(activeComponent)
          ? '!tw-overflow-visible'
          : ''
      }`"
    >
      <div class="container">
        <GoalsPage
          v-if="
            activeComponent === idPage.goalsPage || isLoadPage[idPage.goalsPage]
          "
          :class="[
            activeComponent === idPage.goalsPage ? 'show tw-h-fit' : 'tw-h-fit',
            'slide-item fade',
          ]"
          :is-api-error="
            dataPage[idPage.goalsPage].statusPage === statusPage.Error
          "
          :error-message="dataPage[idPage.goalsPage].errorMessage"
          @check:select="checkSelect"
        />
        <OrgsPage
          v-if="
            activeComponent === idPage.orgsPage || isLoadPage[idPage.orgsPage]
          "
          :class="[
            activeComponent === idPage.orgsPage ? 'show tw-h-fit' : 'tw-h-fit',
            'slide-item fade',
          ]"
          :error-message="dataPage[idPage.orgsPage].errorMessage"
          :is-api-error="
            dataPage[idPage.orgsPage].statusPage === statusPage.Error
          "
          @check:select="checkSelect"
        />
        <WizardQuestions
          v-if="
            activeComponent === idPage.domainPage ||
            isLoadPage[idPage.domainPage]
          "
          ref="domainPageRef"
          :class="[
            activeComponent === idPage.domainPage
              ? 'show tw-h-fit tw-max-w-[800px]'
              : 'tw-h-fit',
            'slide-item fade',
          ]"
          :title="DomainData.title"
          :status-in-page="dataPage[idPage.domainPage]"
          :description="DomainData.description"
          :title-question="DomainData.titleQuestion"
          @change-status-add-domain="handleIsSelected(activeComponent)"
          @on-update="checkAnswer"
        />
        <BrandsPage
          v-if="
            activeComponent === idPage.brandsPage ||
            isLoadPage[idPage.brandsPage]
          "
          ref="brandPageRef"
          :class="[
            activeComponent === idPage.brandsPage
              ? 'show tw-h-fit tw-max-w-[800px]'
              : 'tw-h-fit',
            'slide-item fade',
          ]"
          :status-in-page="dataPage[idPage.brandsPage]"
          :is-api-error="
            dataPage[idPage.brandsPage].statusPage === statusPage.Error
          "
          @change-status-add-brand="handleIsSelected(activeComponent)"
          @on-update="checkAnswer"
        />
        <div
          :class="[
            activeComponent === idPage.servicesPage ? 'show' : '',
            'slide-item fade',
          ]"
        >
          <ServicesPage
            v-if="
              activeComponent === idPage.servicesPage ||
              isLoadPage[idPage.servicesPage]
            "
            ref="servicesPageRef"
            :status-in-page="dataPage[idPage.servicesPage]"
            @change:add:service="handleIsSelected(activeComponent)"
          />
        </div>

        <div
          :class="[
            activeComponent === idPage.webFacingAppPage
              ? 'show tw-h-fit tw-max-w-[800px]'
              : 'tw-h-fit',
            'slide-item fade',
          ]"
        >
          <WebFacingAppPage
            v-if="
              activeComponent === idPage.webFacingAppPage ||
              isLoadPage[idPage.webFacingAppPage]
            "
            ref="webFacingRef"
            :list-web-facing="currentListWebFacing"
            :status-in-page="dataPage[idPage.webFacingAppPage]"
            @on-update="checkAnswer"
            @update:list-web-facing="listWebFacing"
            @change-data-web-facing="handleIsSelected(activeComponent)"
          />
        </div>
        <div
          :class="[
            activeComponent === idPage.sitesPage ? 'show' : '',
            'slide-item fade',
          ]"
        >
          <SitesPage
            v-if="
              activeComponent === idPage.sitesPage ||
              isLoadPage[idPage.sitesPage]
            "
            ref="sitePageRef"
            :status-in-page="dataPage[idPage.sitesPage]"
            @on-update="checkAnswer"
            @check-validate="checkValidateAddSites"
            @change-status-add-sites="handleIsSelected(activeComponent)"
          />
        </div>
        <div
          :class="[
            activeComponent === idPage.teamsPage ? 'show' : '',
            'slide-item fade',
          ]"
        >
          <TeamsPage
            v-if="
              activeComponent === idPage.teamsPage ||
              isLoadPage[idPage.teamsPage]
            "
            ref="teamPageRef"
            :status-in-page="dataPage[idPage.teamsPage]"
            @on-update="checkAnswer"
            @check-validate="checkValidateAddTeams"
            @change-status-add-teams="handleIsSelected(activeComponent)"
          />
        </div>
        <div
          v-if="
            activeComponent === idPage.miscellaneousPage ||
            isLoadPage[idPage.miscellaneousPage]
          "
          :class="[
            activeComponent === idPage.miscellaneousPage ? 'show' : '',
            'slide-item fade',
          ]"
        >
          <MiscellaneousPage
            :status-in-page="dataPage[idPage.miscellaneousPage]"
            @check:answer="checkAnswer"
          />
        </div>
      </div>

      <div class="footer-container tw-flex tw-justify-between tw-my-[40px]">
        <div class="group-button-left">
          <b-button
            variant="primary"
            data-cy="wizard-save-button"
            class="!tw-shadow-none tw-text-[#387DFF] tw-bg-[#FFFFFF] tw-border-none tw-py-[7px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-mr-[14px] tw-rounded-[27px]"
            @click="openModalMoreInfor"
          >
            {{
              getComponentUiText(
                "app-menu-submenu-home-setup-wizard-modal-wrapper-save-button-1",
              )
            }}
          </b-button>
        </div>
        <div class="group-button-right">
          <b-button
            v-if="activeComponent !== idPage.goalsPage"
            data-cy="wizard-previous-button"
            variant="primary"
            class="!tw-shadow-none tw-text-[#387DFF] tw-bg-[#FFFFFF] tw-border-none tw-py-[7px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-mr-[10px] tw-rounded-[27px]"
            @click="handlePrevlou"
          >
            {{
              getComponentUiText(
                "app-menu-submenu-home-setup-wizard-modal-wrapper-previous-button-1",
              )
            }}
          </b-button>

          <b-button
            variant="primary"
            class="!tw-shadow-none tw-bg-[#387DFF] tw-py-[7px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]"
            type="submit"
            data-cy="wizard-next-button"
            @click="
              haldlePrevlouOrNext(
                activeComponent === idPage.miscellaneousPage
                  ? 'finish'
                  : 'next',
              )
            "
          >
            {{
              activeComponent === idPage.miscellaneousPage
                ? getComponentUiText(
                    "app-menu-submenu-home-setup-wizard-modal-wrapper-finish-button-1",
                  )
                : getComponentUiText(
                    "app-menu-submenu-home-setup-wizard-modal-wrapper-next-button-1",
                  )
            }}
          </b-button>
        </div>
      </div>
      <WizardProgressIndictor
        :data="dataPage"
        :active-component-id="activeComponent"
        @on:navigate-item="onClickProgressIndictorItem"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";
import {
  Ref,
  onMounted,
  ref,
  watch,
  reactive,
  onBeforeMount,
  onBeforeUnmount,
  computed,
  h,
} from "vue";
import BrandsPage from "./brandsPage.vue";
import WizardQuestions from "./wizardQuestions.vue";
import GoalsPage from "./goalsPage.vue";
import OrgsPage from "./orgsPage.vue";
import MiscellaneousPage from "./miscellaneousPage.vue";
import TeamsPage from "./teamsPage.vue";
import SitesPage from "./sitesPage.vue";
import ServicesPage from "./servicesPage.vue";
import WizardProgressIndictor from "./wizardProgressIndictor.vue";
import { getDomainFromUrl } from "@/utils/utilities";
import {
  idWizardPage as idPage,
  WIZARD_STATE_PAGE,
  WIZARD_STATE_NAME_FROM_ID,
  localStorageKey,
  idWizardPageIdName,
  WIZARD_STATE_NAME,
  statusPage,
} from "@/utils/constants";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { MODAL_NAME, successStatusCodes } from "@/utils/constants";
import WebFacingAppPage from "./webFacinggAppPage.vue";
import store from "@/store";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { IWizardUpdateQuestionItem } from "@/interfaces/wizard";
import { getCurrentUser } from "@/services/org";
import router from "@/router";
import cloneDeep from "lodash/cloneDeep";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org, UserRoute } from "@/services/apiRoutes/routes";
import { useRoute } from "vue-router";
import { getLocale } from "@/utils/dateTimeUtils";
import { getUpdatedVal } from "@/services/wizard";
import dayjs from "dayjs";
import { CustomExceptionsUIText } from "@/services/apiRoutes/customExceptions";

const route = useRoute();
const activeComponent: Ref<number> = ref(-1);
const currentListWebFacing: any = ref([]);
const isDeleteItemSuccess = ref(false);
const currentOrg: any = computed(() => store.state.Org.currentOrg);
const indexUpdate: any = computed(() => store.state.SetupWizard.indexUpdate);
const questionsSetupWizard: any = computed(
  () => store.state.SetupWizard.questions,
);

let oldValue = null;
const servicesPageRef: any = ref(null);
const brandPageRef: any = ref(null);
const teamPageRef: any = ref(null);
const domainPageRef: any = ref(null);
const sitePageRef: any = ref(null);
const webFacingRef: any = ref(null);
const emit = defineEmits(["update:activeComponent", "get-is-answered"]);
const isAnswered = ref(false);
const valuePage: any = reactive({
  valueSite6: "1",
  valueSite0: null,
  valueSite1: null,
  valueSite2: null,
  valueSite3: null,
  valueSite4: null,
  valueSite5: null,
  valueSite7: "1",
  valueSite8: null,
});

const isLoadPage: any = ref({
  [idPage.goalsPage]: false,
  [idPage.orgsPage]: false,
  [idPage.domainPage]: false,
  [idPage.brandsPage]: false,
  [idPage.servicesPage]: false,
  [idPage.webFacingAppPage]: false,
  [idPage.sitesPage]: false,
  [idPage.teamsPage]: false,
  [idPage.miscellaneousPage]: false,
});

const activeDirection = {
  next: "next",
  prev: "prev",
  save: "save",
};

const props = defineProps({
  showStateComponent: { type: Number, default: -1 },
  isStatusApiSetupReady: { type: Boolean, default: false },
});
onBeforeMount(() => {
  listeningEmitEvent();
  EventEmitter.emit("setZIndexIConNavBar", false);
});

onBeforeUnmount(() => {
  removeEmitEventListener();
});

const originOrgSetupDataWebFacing: any = ref([]);
const originOrgSetupDataBrands: any = ref([]);
const originOrgSetupDataSite: any = ref([]);
const originOrgSetupDataDomain: any = ref([]);
const originOrgSetupDataTeams: any = ref([]);
const originOrgSetupDataMisc: any = ref({});

watch(
  () => activeComponent.value,
  (value, oldData) => {
    // First initialization, Get list questions done.
    if (oldData === -1 && value === 0) {
      const setupWizard = store.state.SetupWizard;

      if (setupWizard.questions[currentOrg.value.id]?.teams[0]?.values) {
        const data = setupWizard.questions[
          currentOrg.value.id
        ].teams[0].values.filter((i) => i.details);

        originOrgSetupDataTeams.value = cloneDeep(data);
      }

      if (setupWizard.questions[currentOrg.value.id]?.misc[0]?.values) {
        const isMiscPiiSelected = setupWizard.questions[
          currentOrg.value.id
        ].misc[0].values.some((item) => item.name && item.endDate == null);

        const isMiscPhiSelected = setupWizard.questions[
          currentOrg.value.id
        ].misc[1].values.some((item) => item.name && item.endDate == null);

        store.commit("SetupWizard/SET_STATE_MISCPII", isMiscPiiSelected);
        store.commit("SetupWizard/SET_STATE_MISCPHI", isMiscPhiSelected);

        originOrgSetupDataMisc.value = {
          miscPII: isMiscPiiSelected,
          miscPHI: isMiscPhiSelected,
        };
      }
    }

    if (oldData >= 0 && dataPage[oldData].statusPage === statusPage.Updating) {
      dataPage[oldData].statusPage = statusPage.NotChange;
    }
    if (dataPage[value].statusPage === statusPage.NotChange) {
      dataPage[value].statusPage = statusPage.Updating;
    }
    if (
      value === idPage.webFacingAppPage &&
      originOrgSetupDataWebFacing.value.length === 0
    )
      setTimeout(() => {
        originOrgSetupDataWebFacing.value = cloneDeep(
          currentListWebFacing.value,
        );
      }, 1000);
    if (
      value === idPage.brandsPage &&
      originOrgSetupDataBrands.value.length === 0
    )
      setTimeout(() => {
        originOrgSetupDataBrands.value = cloneDeep(
          questionsSetupWizard.value[
            currentOrg.value.id
          ].brands[0].values?.filter((el) => !el.isArchived),
        );
      }, 1000);
    if (value === idPage.sitesPage && originOrgSetupDataSite.value.length === 0)
      setTimeout(() => {
        originOrgSetupDataSite.value = cloneDeep(
          questionsSetupWizard.value[currentOrg.value.id]?.sites[0].values,
        );
      }, 1000);
    if (
      value === idPage.domainPage &&
      originOrgSetupDataDomain.value.length === 0
    )
      setTimeout(() => {
        originOrgSetupDataDomain.value = cloneDeep(
          questionsSetupWizard.value[
            currentOrg.value.id
          ].domains[0].values?.filter((el) => !el.isArchived),
        );
      }, 1000);

    if (value !== -1 && isLoadPage.value[value] === false) {
      isLoadPage.value[value] = true;
    }
  },
);

const listeningEmitEvent = () => {
  EventEmitter.on("saveAndExit", callApiQuestion);
  EventEmitter.on(EmitterEvents.OPEN_WIZARD_DELETE_MODAL, openModalDeleteItem);
};
const removeEmitEventListener = () => {
  EventEmitter.off("saveAndExit");
  EventEmitter.off(EmitterEvents.OPEN_WIZARD_DELETE_MODAL);
};
watch(isAnswered, (value) => {
  emit("get-is-answered", value);
});
const listWebFacing = (data) => {
  currentListWebFacing.value = data;
};
const callApiQuestion = async (value) => {
  const isValid = await validateForm();
  if (!isValid) {
    return;
  }

  await handleCallApiPageSetup(
    activeComponent.value,
    null,
    activeDirection.save,
  );

  if (activeComponent.value !== idPage.webFacingAppPage) {
    store.dispatch("SetupWizard/onModalSetupWizard", false);
    if (!value) {
      router.push({ path: "/" });
    }
  }
};
const areAllValuesSet = () => {
  for (const key in valuePage) {
    if (valuePage[key] === null || valuePage[key] === "") {
      return false;
    }
  }
  return true;
};
const checkSelect = (value) => {
  valuePage[`valueSite${activeComponent.value}`] = value;
  isAnswered.value = true;
  handleIsSelected(activeComponent.value);
};
const checkAnswer = (answer) => {
  valuePage[`valueSite${activeComponent.value}`] = answer;
  if (typeof answer == "number") {
    isAnswered.value = true;
  } else {
    isAnswered.value = false;
  }
  handleIsSelected(activeComponent.value);
  if (valuePage.valueSite3 == 0) {
    handleSectionsChange({
      status: false,
      namePage: WIZARD_STATE_PAGE.BRANDS,
      isSelectedPage: "isSelectedBrands",
    });
  }
  if (valuePage.valueSite2 == 0) {
    handleSectionsChange({
      status: false,
      namePage: WIZARD_STATE_PAGE.DOMAINS,
      isSelectedPage: "isSelectedDomains",
    });
  }
  if (valuePage.valueSite7 == 0) {
    handleSectionsChange({
      status: false,
      namePage: WIZARD_STATE_PAGE.TEAMS,
      isSelectedPage: "isSelectedTeams",
    });
  }
};
const openModalMoreInfor = () => {
  if (areAllValuesSet()) {
    isAnswered.value = true;
  } else {
    isAnswered.value = false;
  }
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
    properties: {
      isMoreInfoModal: true,
      isAnswered: isAnswered.value,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
const haldlePrevlouOrNext = async (value) => {
  const currentActvieComponent = cloneDeep(activeComponent.value);
  const isValid = await validateForm();
  if (!isValid) {
    return;
  }
  isAnswered.value = false;
  if (value == "next" && activeComponent.value < 8) {
    if (activeComponent.value !== idPage.webFacingAppPage) {
      activeComponent.value += 1;
    }
    if (typeof valuePage[`valueSite${activeComponent.value}`] == "number") {
      isAnswered.value = true;
    } else {
      isAnswered.value = false;
    }
  } else if (value == WIZARD_STATE_PAGE.FINISH && areAllValuesSet()) {
    isAnswered.value = true;
    openModalMoreInfor();
  } else if (value == WIZARD_STATE_PAGE.FINISH && !areAllValuesSet()) {
    isAnswered.value = false;
    openModalMoreInfor();
  }
  if (value !== WIZARD_STATE_PAGE.FINISH) {
    handleCallApiPageSetup(currentActvieComponent, null, activeDirection.next);
  }

  emit("update:activeComponent", activeComponent.value);
};

const handleCallApiPageSetup = async (
  _activeComponent,
  dataDeleteItem?,
  activeDirection?,
) => {
  if (
    _activeComponent === idPage.goalsPage &&
    questionsSetupWizard.value[currentOrg.value.id]?.goals[0].isSelectedGoals
  ) {
    hanldleSetupOrgGoals();
  }
  if (
    _activeComponent === idPage.domainPage &&
    (questionsSetupWizard.value[currentOrg.value.id]?.domains[0]
      .isSelectedDomains ||
      dataDeleteItem)
  ) {
    handleSetupDomain(dataDeleteItem);
  }
  if (
    _activeComponent === idPage.brandsPage &&
    (questionsSetupWizard.value[currentOrg.value.id]?.brands[0]
      .isSelectedBrands ||
      dataDeleteItem)
  ) {
    handleSetupBrand(dataDeleteItem);
  }
  if (
    _activeComponent === idPage.servicesPage &&
    (questionsSetupWizard.value[currentOrg.value.id]?.services[0]
      .isSelectedServices ||
      dataDeleteItem)
  ) {
    handleSetupServices(dataDeleteItem);
  }
  if (
    _activeComponent === idPage.orgsPage &&
    questionsSetupWizard.value[currentOrg.value.id]?.org[0].isSelectedOrg
  ) {
    hanldleSetupOrg();
  }
  if (
    _activeComponent === idPage.teamsPage &&
    (questionsSetupWizard.value[currentOrg.value.id]?.teams[0]
      .isSelectedTeams ||
      dataDeleteItem)
  ) {
    handleSetupTeams(dataDeleteItem);
  }

  if (
    _activeComponent === idPage.miscellaneousPage &&
    activeDirection !== activeDirection.next &&
    activeDirection !== idPage.teamsPage
  ) {
    await handleSetupMisc();
  }

  if (
    _activeComponent === idPage.sitesPage &&
    (questionsSetupWizard.value[currentOrg.value.id]?.sites[0]
      .isSelectedSites ||
      dataDeleteItem)
  ) {
    hanldleSetupSite(dataDeleteItem);
  }
  if (_activeComponent === idPage.webFacingAppPage) {
    if (
      questionsSetupWizard.value[currentOrg.value.id]?.webservices[0]
        .isSelectedWebFacing ||
      dataDeleteItem
    ) {
      if (!oldValue || oldValue.length === 0) {
        oldValue = cloneDeep(
          questionsSetupWizard.value[currentOrg.value.id].webservices[0].values,
        );
      }
      hanldleSetupWebFacing(dataDeleteItem, activeDirection);
    } else {
      directionActivePAge(activeDirection);
    }
  }
  store.dispatch("SetupWizard/handleSetQuestionCache");
};
const handlePrevlou = async () => {
  const currentActvieComponent = cloneDeep(activeComponent.value);
  const isValid = await validateForm();
  if (!isValid) {
    return;
  }
  isAnswered.value = false;
  if (activeComponent.value > 0 && activeComponent.value) {
    if (activeComponent.value !== idPage.webFacingAppPage) {
      activeComponent.value -= 1;
    }
    if (typeof valuePage[`valueSite${activeComponent.value}`] == "number") {
      isAnswered.value = true;
    } else {
      isAnswered.value = false;
    }
  }

  handleCallApiPageSetup(currentActvieComponent, null, activeDirection.prev);
};

const validateForm = async () => {
  let isValid = true;
  switch (activeComponent.value) {
    case idPage.servicesPage:
      isValid = await servicesPageRef.value.checkAllValidations();
      break;
    case idPage.brandsPage:
      isValid = await brandPageRef.value.checkAllValidations();
      break;
    case idPage.teamsPage:
      if (!valuePage.valueSite7) {
        isValid = true;
      } else {
        isValid = await teamPageRef.value.checkAllValidations();
        if (!isValid) {
          teamPageRef.value.showDetails();
        }
      }
      break;
    case idPage.domainPage:
      isValid = await domainPageRef.value.checkAllValidations();
      break;
    case idPage.sitesPage:
      if (!valuePage.valueSite6) {
        isValid = true;
      } else {
        isValid = await sitePageRef.value.checkAllValidations();
        if (!isValid) {
          sitePageRef.value.showDetails();
        }
      }
      break;
    case idPage.webFacingAppPage:
      isValid = await webFacingRef.value.checkAllValidations();
      break;

    default:
      break;
  }
  return isValid;
};
const checkValidateAddTeams = () => {
  valuePage.valueSite7 = "1";
};
const checkValidateAddSites = () => {
  valuePage.valueSite6 = "1";
};

const hanldleSetupOrgGoals = async () => {
  try {
    dataPage[idPage.goalsPage].statusPage = statusPage.CallApi;
    const res = await store.dispatch("SetupWizard/haldleSetupOrgGoals");
    if (res.data) {
      dataPage[idPage.goalsPage].statusPage = statusPage.Success;
    }
  } catch (error: any) {
    dataPage[idPage.goalsPage].statusPage = statusPage.Error;
    showErrorAPI(error, Org.postGoalSetup);
  } finally {
    handleSectionsChange({
      status: false,
      namePage: WIZARD_STATE_PAGE.GOALS,
      isSelectedPage: "isSelectedGoals",
    });
  }
};
const handleSetupTeams = async (dataDeleteItem) => {
  const keysToCheck = [
    "details",
    "headcount",
    "notes",
    "siteId",
    "startDate",
    "teamLegalTypeId",
    "teamTypeId",
  ];
  let listUpdated: any[] = [];

  try {
    dataDeleteItem?.type === "UPDATE" && keysToCheck.push("endDate");

    const setupWizard = store.state.SetupWizard.questions;
    const currentTeamsData = setupWizard[currentOrg.value.id].teams[0].values;

    for (const currentItem of currentTeamsData) {
      const originalItem = originOrgSetupDataTeams.value.find(
        (item) => item.id === currentItem.id,
      );

      if (!originalItem) listUpdated.push(currentItem);
      else {
        const updatedItem = getUpdatedVal(
          originalItem,
          currentItem,
          keysToCheck,
        );

        if (updatedItem && Object.keys(updatedItem).length > 0)
          listUpdated.push({ ...updatedItem, id: currentItem.id });
      }
    }

    if (dataDeleteItem?.type === "DELETE" && dataDeleteItem.item?.id) {
      const index = originOrgSetupDataTeams.value.findIndex(
        (item) => item.id && item.id === dataDeleteItem.item?.id,
      );

      originOrgSetupDataTeams.value[index] = cloneDeep(currentTeamsData[index]);

      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.teamsPage, dataDeleteItem),
      );

      return;
    }

    if (dataDeleteItem?.type === "UPDATE" && dataDeleteItem?.item?.id) {
      const index = listUpdated.findIndex(
        (item) => item.id && item.id === dataDeleteItem.item?.id,
      );

      if (index !== -1) listUpdated = [listUpdated[index]];
    }

    if (listUpdated.length === 0) return;

    dataPage[idPage.teamsPage].statusPage = statusPage.CallApi;

    const res = await store.dispatch(
      "SetupWizard/hanldleSetupTeams",
      listUpdated,
    );

    await new Promise((resolve) => setTimeout(resolve, 350));

    if (dataDeleteItem) {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.teamsPage, dataDeleteItem),
      );
    }

    if (!dataDeleteItem) {
      store.commit("SetupWizard/SET_VALUES_TEAM", {
        value: res.data.data.sections[0].questions[0].values.filter(
          (el) => !el.isArchived,
        ),
        currentOrg: currentOrg.value.id,
      });
    }

    dataPage[idPage.teamsPage].dataError = [];
    dataPage[idPage.teamsPage].statusPage = statusPage.Success;
    originOrgSetupDataTeams.value = cloneDeep(
      res.data.data.sections[0].questions[0].values.filter(
        (el) => !el.isArchived,
      ),
    );
  } catch (error: any) {
    if (error) {
      dataPage[idPage.teamsPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.teamsPage].statusPage = statusPage.Error;
    dataPage[idPage.teamsPage].dataError = listUpdated as any;
    // showErrorAPI(error, Org.postTeamsSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.TEAMS,
        isSelectedPage: "isSelectedTeams",
      });
    }
  }
};

const handleSetupMisc = async () => {
  let updateMiscPII = false;
  let updateMiscPHI = false;

  try {
    if (
      dataPage[idPage.miscellaneousPage].dataError.length > 0 &&
      ("miscPII" in dataPage[idPage.miscellaneousPage].dataError[0] ||
        "miscPHI" in dataPage[idPage.miscellaneousPage].dataError[0])
    )
      return;

    const currentValue = store.state.SetupWizard.valueMisc;

    if (currentValue?.miscPII !== originOrgSetupDataMisc.value.miscPII) {
      updateMiscPII = true;
    }

    if (currentValue?.miscPHI !== originOrgSetupDataMisc.value.miscPHI) {
      updateMiscPHI = true;
    }

    if (!updateMiscPII && !updateMiscPHI) return;

    dataPage[idPage.miscellaneousPage].statusPage = statusPage.CallApi;
    const res = await store.dispatch("SetupWizard/hanldleSetupMisc", {
      updateMiscPII,
      updateMiscPHI,
    });

    dataPage[idPage.miscellaneousPage].dataError = [];
    dataPage[idPage.miscellaneousPage].statusPage = statusPage.Success;
    originOrgSetupDataMisc.value = cloneDeep(currentValue);

    store.commit("SetupWizard/SET_VALUE_MISC", {
      value: res.data.data.sections[0].questions,
      currentOrg: currentOrg.value.id,
    });

    // Waiting for loading animation.
    await new Promise((resolve) => setTimeout(resolve, 1450));
  } catch (error: any) {
    if (error) {
      dataPage[idPage.miscellaneousPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.miscellaneousPage].statusPage = statusPage.Error;
    dataPage[idPage.miscellaneousPage].dataError = [
      {
        ...(updateMiscPII ? { miscPII: true } : {}),
        ...(updateMiscPHI ? { miscPHI: true } : {}),
      } as never,
    ];
    // showErrorAPI(error, Org.postMiscSetup);
  } finally {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.MISC,
      isSelectedPage: "isSelectedMisc",
    });
  }
};

const hanldleSetupSite = async (dataDeleteItem) => {
  const updatedValues: any = [];
  try {
    if (dataDeleteItem?.type === "DELETE") {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.sitesPage, dataDeleteItem),
      );
      return;
    }
    const isCheckValueSite = questionsSetupWizard.value[
      currentOrg.value.id
    ]?.sites[0].values.some(
      (site) =>
        !!site.typeId ||
        !!site.legalTypeId ||
        (Array.isArray(site.siteAttributes) && site.siteAttributes.length > 0),
    );
    if (!isCheckValueSite) return;

    const currentValue = cloneDeep(
      questionsSetupWizard.value[currentOrg.value.id]?.sites[0].values,
    );
    const keyToCheck = [
      "name",
      "address1",
      "address2",
      "address3",
      "typeId",
      "legalTypeId",
      "townCity",
      "postcode",
      "countryId",
      "phoneNumber",
      "details",
      "notes",
    ];
    if (dataDeleteItem?.type === "UPDATE") {
      keyToCheck.push("endDate");
    }
    currentValue.forEach((item) => {
      if (!item.id && !dataDeleteItem) {
        // countryId and address 1 canbe null
        if (item.countryId === null) {
          delete item.countryId;
        }
        if (item.address1 === null || item.address1 === "") {
          delete item.address1;
        }
        if (item.startDate === null || item.startDate === "") {
          delete item.startDate;
        }
        if (item.countryId === null || item.countryId === "") {
          delete item.countryId;
        }
        delete item.showAccordion;
        delete item.isCollapse;
        delete item.showMoreDetail;
        delete item.isCallAPI;
        updatedValues.push(item);
      } else if (item.id) {
        const oldValue = originOrgSetupDataSite.value.find(
          (el) => el.id === item.id,
        );
        const updatedValue: any = getUpdatedVal(oldValue, item, keyToCheck);
        const updatedSiteAttributes: any = [];
        // check new siteAttributes array
        item.siteAttributes.forEach((el) => {
          const isExist = oldValue.siteAttributes.some((oldEl) => {
            return oldEl.attributeTypeId === el.attributeTypeId;
          });
          if (!isExist) {
            updatedSiteAttributes.push({ attributeTypeId: el.attributeTypeId });
          }
        });
        // check delete siteAttributes array
        oldValue.siteAttributes
          .filter((itemF) => !itemF.isArchived)
          .forEach((oldEl) => {
            const isExist = item.siteAttributes.some((el) => {
              return oldEl.attributeTypeId === el.attributeTypeId;
            });
            if (!isExist) {
              updatedSiteAttributes.push({ id: oldEl.id, isArchived: true });
            }
          });
        if (updatedSiteAttributes && updatedSiteAttributes.length > 0) {
          updatedValue.siteAttributes = updatedSiteAttributes;
        }
        if (updatedValue && Object.keys(updatedValue).length > 0) {
          updatedValues.push({
            ...updatedValue,
            id: item.id,
          });
        }
      }
    });
    if (updatedValues.length === 0) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.SITES,
        isSelectedPage: "isSelectedSites",
      });
      return;
    }
    dataPage[idPage.sitesPage].statusPage = statusPage.CallApi;
    const res = await store.dispatch("SetupWizard/hanldleSetupSite", {
      data: updatedValues,
    });
    originOrgSetupDataSite.value = cloneDeep(
      res.data.data.sections[0].questions[0].values?.filter(
        (el) => !el.isArchived,
      ) || [],
    );
    dataPage[idPage.sitesPage].statusPage = statusPage.Success;
    if (dataDeleteItem) {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.sitesPage, dataDeleteItem),
      );
    }
    if (!dataDeleteItem) {
      store.commit("SetupWizard/SET_VALUES_SITES", {
        value: res.data.data.sections[0].questions[0].values.filter(
          (el) => !el.isArchived,
        ),
        currentOrg: currentOrg.value.id,
      });
    }
  } catch (error: any) {
    if (error) {
      dataPage[idPage.sitesPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.sitesPage].statusPage = statusPage.Error;
    dataPage[idPage.sitesPage].dataError = updatedValues;
    // showErrorAPI(error, Org.postSiteSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.SITES,
        isSelectedPage: "isSelectedSites",
      });
    }
  }
};

const handleSetupDomain = async (dataDeleteItem) => {
  const updatedValues: any = [];
  try {
    if (dataDeleteItem?.type === "DELETE") {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.domainPage, dataDeleteItem),
      );
      return;
    }
    const keyToCheck: any = [];
    if (dataDeleteItem?.type === "UPDATE") {
      keyToCheck.push("endDate");
    }
    const currentValue = cloneDeep(
      questionsSetupWizard.value[currentOrg.value.id].domains[0].values,
    );
    currentValue.forEach((item) => {
      if (!item.id && !dataDeleteItem) {
        updatedValues.push({
          domainName: item.domainName,
          startDate: item.startDate,
        });
      } else if (item.id) {
        const oldValue = originOrgSetupDataDomain.value.find(
          (el) => el.id === item.id,
        );
        const updatedValue: any = getUpdatedVal(oldValue, item, keyToCheck);
        if (updatedValue && Object.keys(updatedValue).length > 0) {
          updatedValues.push({
            ...updatedValue,
            id: item.id,
          });
        }
      }
    });
    if (updatedValues.length === 0) {
      if (
        (dataPage[idPage.domainPage].statusPage = statusPage.Success) ||
        (dataPage[idPage.domainPage].statusPage = statusPage.Error)
      ) {
        dataPage[idPage.domainPage].statusPage = statusPage.NotChange;
        dataPage[idPage.domainPage].dataError = [];
      }
      dataPage[idPage.domainPage].statusPage = statusPage.Updating;
      return;
    }
    dataPage[idPage.domainPage].statusPage = statusPage.CallApi;
    dataPage[idPage.domainPage].dataError = [];
    const res = await store.dispatch("SetupWizard/handleSetupDomain", {
      data: updatedValues,
    });
    originOrgSetupDataDomain.value = cloneDeep(
      res.data.data.sections[0].questions[0].values.filter(
        (el) => !el.isArchived,
      ),
    );
    dataPage[idPage.domainPage].statusPage = statusPage.Success;
    if (dataDeleteItem) {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.domainPage, dataDeleteItem),
      );
    }
    if (!dataDeleteItem) {
      store.commit("SetupWizard/SET_POST_DOMAIN_NAME", {
        data: res.data.data.sections[0].questions[0].values.filter(
          (el) => !el.isArchived,
        ),
        currentOrg: currentOrg.value.id,
      });
    }
  } catch (error: any) {
    if (error) {
      dataPage[idPage.domainPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.domainPage].statusPage = statusPage.Error;
    dataPage[idPage.domainPage].dataError = updatedValues;
    // showErrorAPI(error, Org.postDomainSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.DOMAINS,
        isSelectedPage: "isSelectedDomains",
      });
    }
  }
};
const hanldleSetupOrg = async () => {
  try {
    dataPage[idPage.orgsPage].statusPage = statusPage.CallApi;
    const res = await store.dispatch("SetupWizard/handleSetupOrg");
    if (res.data) {
      dataPage[idPage.orgsPage].statusPage = statusPage.Success;
    }
  } catch (error: any) {
    if (error) {
      dataPage[idPage.orgsPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.orgsPage].statusPage = statusPage.Error;
    // showErrorAPI(error, Org.postOrgSetup);
  } finally {
    handleSectionsChange({
      status: false,
      namePage: WIZARD_STATE_PAGE.ORG,
      isSelectedPage: "isSelectedOrg",
    });
  }
};
const handleSetupBrand = async (dataDeleteItem) => {
  const updatedValues: any = [];
  try {
    if (dataDeleteItem?.type === "DELETE") {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.brandsPage, dataDeleteItem),
      );
      return;
    }
    const keyToCheck: any = ["brandName"];
    if (dataDeleteItem?.type === "UPDATE") {
      keyToCheck.push("endDate");
    }
    const currentValue = cloneDeep(
      questionsSetupWizard.value[currentOrg.value.id]?.brands[0].values,
    );
    currentValue.forEach((item) => {
      if (!item.id && !dataDeleteItem) {
        updatedValues.push({
          brandName: item.brandName,
          startDate: item.startDate,
        });
      } else if (item.id) {
        const oldValue = originOrgSetupDataBrands.value.find(
          (el) => el.id === item.id,
        );
        const updatedValue: any = getUpdatedVal(oldValue, item, keyToCheck);
        if (updatedValue && Object.keys(updatedValue).length > 0) {
          updatedValues.push({
            ...updatedValue,
            id: item.id,
          });
        }
      }
    });
    if (updatedValues.length === 0) {
      if ((dataPage[idPage.brandsPage].statusPage = statusPage.Success)) {
        dataPage[idPage.brandsPage].statusPage = statusPage.Success;
        dataPage[idPage.brandsPage].dataError = [];
      }
      return;
    }
    dataPage[idPage.brandsPage].statusPage = statusPage.CallApi;
    dataPage[idPage.brandsPage].dataError = [];

    // if (!isCallAPI) {
    //   dataPage[idPage.brandsPage].dataError =
    //     listWebFiltered.concat(listAppFiltered);
    //   return;
    // }
    const res = await store.dispatch("SetupWizard/hanldleSetupBrand", {
      data: updatedValues,
    });

    if (res) {
      originOrgSetupDataBrands.value = cloneDeep(
        res.data.data.sections[0].questions[0].values.filter(
          (el) => !el.isArchived,
        ),
      );
      dataPage[idPage.brandsPage].statusPage = statusPage.Success;
    }
    if (!dataDeleteItem) {
      store.commit("SetupWizard/SET_POST_BRAND_NAME", {
        data: res.data.data.sections[0].questions[0].values.filter(
          (el) => !el.isArchived,
        ),
        currentOrg: currentOrg.value.id,
      });
    }
  } catch (error: any) {
    if (error) {
      dataPage[idPage.brandsPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.brandsPage].statusPage = statusPage.Error;
    dataPage[idPage.brandsPage].dataError = updatedValues;
    // showErrorAPI(error, Org.postBrandSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.BRANDS,
        isSelectedPage: "isSelectedBrands",
      });
    }
  }
};

const handleSetupServices = async (dataDeleteItem) => {
  try {
    if (dataDeleteItem?.type === "DELETE" && dataDeleteItem.item.id) {
      const dataStore: IWizardUpdateQuestionItem = {
        item: {},
        index: dataDeleteItem.item?.indexUpdate ?? dataDeleteItem.index,
        type: "DELETE",
        currentOrg: currentOrg.value.id,
        namePage: WIZARD_STATE_NAME_FROM_ID[idPage.servicesPage],
      };
      store.dispatch("SetupWizard/updateValuesItem", dataStore);
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.servicesPage, dataDeleteItem),
      );
      return;
    }
    let indexGroup, indexCurrent;
    if (dataDeleteItem) {
      indexGroup = cloneDeep(dataDeleteItem.item.indexGroup);
      indexCurrent = cloneDeep(dataDeleteItem.item.indexCurrent);
    }
    dataPage[idPage.servicesPage].statusPage = statusPage.CallApi;
    const res = await store.dispatch(
      "SetupWizard/handleSetupServices",
      dataDeleteItem?.item,
    );
    if (dataDeleteItem) {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.servicesPage, dataDeleteItem),
      );
    }
    if (!dataDeleteItem) {
      store.commit("SetupWizard/SET_VALUES_SERVICE", {
        value: res.data.data.sections[0].questions[0].values.filter(
          (el) => !el.isArchived,
        ),
        currentOrg: currentOrg.value.id,
      });
    }
    if (dataDeleteItem && dataDeleteItem.type === "UPDATE") {
      const services = res.data.data.sections[0].questions[0].values;
      const dataUpdate = services.find(
        (el: any) => el.id === dataDeleteItem.item.id,
      );
      EventEmitter.emit(EmitterEvents.SERVICE_UPDATE_ITEM, {
        dataUpdate,
        indexGroup,
        indexCurrent,
      });
      store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
        value: dataUpdate,
        indexUpdate: dataDeleteItem.index,
        currentOrg: currentOrg.value.id,
      });
    }
    dataPage[idPage.servicesPage].statusPage = statusPage.Success;
    dataPage[idPage.servicesPage].dataError = [];
  } catch (error: any) {
    if (error.error) {
      dataPage[idPage.servicesPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error.error?.data?.error?.type],
      );
    }
    dataPage[idPage.servicesPage].statusPage = statusPage.Error;
    dataPage[idPage.servicesPage].dataError = error.dataError;
    // showErrorAPI(error, Org.postServicesSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.SERVICES,
        isSelectedPage: "isSelectedServices",
      });
    }
  }
};

const hanldleSetupWebFacingCallAction = async (
  dataDeleteItem,
  isCallAPI = true,
) => {
  let listWeb,
    listApp,
    listWebFiltered: any = [],
    listAppFiltered: any = [];
  try {
    dataPage[idPage.webFacingAppPage].dataError = [];

    if (indexUpdate.value !== null) {
      listWeb = currentListWebFacing.value.filter(
        (el: any, index: number) =>
          el.isStatus === 1 && el.name && el.url && indexUpdate.value === index,
      );
      listApp = currentListWebFacing.value.filter(
        (el: any, index: number) =>
          el.isStatus === 0 && el.name && indexUpdate.value === index,
      );
    } else {
      listWeb = currentListWebFacing.value.filter(
        (el: any) => el.isStatus === 1 && el.name && el.url && !el.isArchived,
      );
      listApp = currentListWebFacing.value.filter(
        (el: any) => el.isStatus === 0 && el.name && !el.isArchived,
      );
    }

    if (listWeb.length === 0 && listApp.length == 0) return;

    const keysToCheck = [
      "serviceTypeId",
      "url",
      "notes",
      "startDate",
      "name",
      "description",
      "isArchived",
      "appName",
      "isMobile",
      "isDesktop",
      "typeId",
    ];

    if (dataDeleteItem?.type === "UPDATE") {
      keysToCheck.push("endDate");
    }

    // filter data before call api
    listApp.map((el) => {
      if (!el.isArchived) {
        if (!el.id && !dataDeleteItem) {
          listAppFiltered.push(el);
        } else if (el.id) {
          const oldData = originOrgSetupDataWebFacing.value.find(
            (item: any) =>
              item.id === el.id && item.serviceTypeId === el.serviceTypeId,
          );
          const updatedVal = getUpdatedVal(oldData, el, keysToCheck);
          if (Object.keys(updatedVal).length > 0) {
            listAppFiltered.push({ ...updatedVal, id: el.id });
          }
        }
      } else {
        listAppFiltered.push({
          id: el.id,
          isArchived: el.isArchived,
        });
      }
    });

    listWeb.map((el) => {
      if (!el.isArchived) {
        if (!el.id && !dataDeleteItem) {
          listWebFiltered.push(el);
        } else if (el.id) {
          const oldData = originOrgSetupDataWebFacing.value.find(
            (item: any) =>
              item.id === el.id && item.serviceTypeId === el.serviceTypeId,
          );
          const updatedVal = getUpdatedVal(oldData, el, keysToCheck);
          if (Object.keys(updatedVal).length > 0) {
            listWebFiltered.push({ ...updatedVal, id: el.id });
          }
        }
      } else {
        listWebFiltered.push({
          id: el.id,
          isArchived: el.isArchived,
        });
      }
    });
    if (listWebFiltered.length === 0 && listAppFiltered.length === 0) {
      if (dataPage[idPage.webFacingAppPage].statusPage === statusPage.Error) {
        dataPage[idPage.webFacingAppPage].statusPage = statusPage.Success;
        dataPage[idPage.webFacingAppPage].dataError = [];
      }
      return;
    }
    if (!isCallAPI) {
      dataPage[idPage.webFacingAppPage].dataError = listWebFiltered
        .map((item) => {
          return {
            ...item,
            serviceTypeId: WIZARD_STATE_PAGE.WEBSITE,
          };
        })
        .concat(
          listAppFiltered.map((item) => {
            return {
              ...item,
              serviceTypeId: WIZARD_STATE_PAGE.WEBNAT,
            };
          }),
        );
      return;
    }
    dataPage[idPage.webFacingAppPage].statusPage = statusPage.CallApi;
    dataPage[idPage.webFacingAppPage].dataError = [];

    let res = await store.dispatch("SetupWizard/hanldleSetupWebFacing", {
      listWeb: listWebFiltered,
      listApp: listAppFiltered,
      isDelete: dataDeleteItem?.type === "DELETE",
    });
    if (!res) res = dataDeleteItem.res.data;
    currentListWebFacing.value = currentListWebFacing.value.filter(
      (el: any) => !el.isArchived,
    );
    let questions = res.data?.data?.sections[0]?.questions || [];
    questions = questions[0].values
      .concat(questions[1].values)
      .filter((el: any) => !el.isArchived);
    originOrgSetupDataWebFacing.value = questions;
    originOrgSetupDataWebFacing.value = originOrgSetupDataWebFacing.value.map(
      (item) => {
        if (item.serviceTypeId === WIZARD_STATE_PAGE.WEBSITE) {
          return {
            ...item,
            name: item.description,
            isWebsite: 1,
          };
        }
        return {
          ...item,
          name: item.appName,
          isWebsite: 0,
        };
      },
    );
    dataPage[idPage.webFacingAppPage].statusPage = statusPage.Success;
    if (dataDeleteItem) {
      showSuccessToast(
        getMessageSuccessDeleteItem(idPage.webFacingAppPage, dataDeleteItem),
      );
    }

    let data = res.data.data.sections[0].questions;
    oldValue = data[0].values;
    if (!dataDeleteItem) {
      data.forEach((e: any, index) => {
        e.values.forEach((el: any) => {
          if (index == 0) {
            el.isWebsite = 1;
          } else {
            el.isWebsite = 0;
          }
        });
      });

      data = data.map((e: any) => {
        return {
          ...e,
          values: e.values.filter((el: any) => !el.isArchived),
        };
      });
      store.commit("SetupWizard/SET_VALUES_WEBSERVICES", data);
    }

    if (dataDeleteItem?.type === "DELETE") return;
  } catch (error: any) {
    if (error) {
      dataPage[idPage.webFacingAppPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    dataPage[idPage.webFacingAppPage].statusPage = statusPage.Error;
    if (dataDeleteItem && dataDeleteItem?.type === "UPDATE") {
      dataPage[idPage.webFacingAppPage].dataError = listWebFiltered
        .map((item) => {
          return {
            ...item,
            serviceTypeId: WIZARD_STATE_PAGE.WEBSITE,
          };
        })
        .concat(
          listAppFiltered.map((item) => {
            return {
              ...item,
              serviceTypeId: WIZARD_STATE_PAGE.WEBNAT,
            };
          }),
        )
        .map((item) => {
          return {
            id: item.id,
            isDelete: true,
            serviceTypeId: item.serviceTypeId,
          };
        });
      // dataPage[idPage.webFacingAppPage].dataError =
      //   listWebFiltered.concat(listAppFiltered);
    } else {
      dataPage[idPage.webFacingAppPage].dataError = listWebFiltered
        .map((item) => {
          return {
            ...item,
            serviceTypeId: WIZARD_STATE_PAGE.WEBSITE,
          };
        })
        .concat(
          listAppFiltered.map((item) => {
            return {
              ...item,
              serviceTypeId: WIZARD_STATE_PAGE.WEBNAT,
            };
          }),
        );
    }
    if (error) {
      dataPage[idPage.sitesPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    // showErrorAPI(error, Org.postSiteSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.WEBSERVICES,
        isSelectedPage: "isSelectedWebFacing",
      });
    }
  }
};

const hanldleSetupWebFacing = async (dataDeleteItem, activeDirection) => {
  try {
    // Validate url belong to domain of org
    const listUrl = currentListWebFacing.value.filter(
      (el: any) => el.name && el.url,
    );
    if (listUrl.length > 0) {
      const domains =
        questionsSetupWizard.value[currentOrg.value.id]?.domains[0].values;
      const urls = listUrl.map((el) => ({
        ...el,
        domainName: getDomainFromUrl(el.url),
      }));
      // find url not belong to domains
      const urlNotBelongToDomain = urls.filter((url: any) => {
        const data = domains.find((domain: any) => {
          return (
            !domain.isArchived &&
            (`${url.domainName}`.endsWith(domain.domainName) ||
              `${domain.domainName}`.endsWith(url.domainName))
          );
        });
        return !url.isArchived && !data;
      });

      let domainList = urlNotBelongToDomain.map((el) => el.domainName);
      domainList = [...new Set(domainList)];
      if (urlNotBelongToDomain.length > 0) {
        const emitData: IModalMessage = {
          component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
          properties: {
            value: {},
            title: getComponentUiText(
              "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-title-1",
            ),
            description:
              domainList.length == 1
                ? `${getComponentUiText(
                    "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-description-1",
                  )}:`
                : `${getComponentUiText(
                    "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-description-2",
                  )}:`,
            list: domainList,
            buttonText:
              domainList.length == 1
                ? getComponentUiText(
                    "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-title-1",
                  )
                : getComponentUiText(
                    "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-title-2",
                  ),
            buttonRed: false,
            hiddenHelp: false,
            slotCustom: h("div", {
              innerHTML: `<div class="tw-text-[#231F20] tw-text-[14px]">
                <p>${
                  domainList.length == 1
                    ? getComponentUiText(
                        "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domains-sub-description-1",
                      )
                    : getComponentUiText(
                        "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domains-sub-description-2",
                      )
                }</p>
                      <p class="tw-mt-[4px]">${
                        domainList.length == 1
                          ? getComponentUiText(
                              "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-helper-text-1",
                            )
                          : getComponentUiText(
                              "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-helper-text-2",
                            )
                      }</p>
              </div>`,
            }),
          },
          events: {
            "update:data": async () => {
              dataPage[idPage.webFacingAppPage].statusPage = statusPage.CallApi;
              const domainForPost = domainList.map((el) => ({
                domainName: el,
              }));
              try {
                const postDomains = await store.dispatch(
                  "SetupWizard/handleSetupForceDomain",
                  {
                    domains: domainForPost,
                    currentOrg: currentOrg.value.id,
                  },
                );
                if (
                  postDomains &&
                  postDomains.status === successStatusCodes.OK
                ) {
                  directionActivePAge(activeDirection);
                  hanldleSetupWebFacingCallAction(dataDeleteItem);
                } else {
                  dataPage[idPage.webFacingAppPage].statusPage =
                    statusPage.Error;
                  hanldleSetupWebFacingCallAction(dataDeleteItem, false);
                  urlNotBelongToDomain.forEach((data) => {
                    currentListWebFacing.value =
                      currentListWebFacing.value.filter(
                        (item) =>
                          !item.url ||
                          getDomainFromUrl(item.url) !== data.domainName,
                      );
                  });
                  if (postDomains?.data?.error) {
                    dataPage[idPage.webFacingAppPage].errorMessage =
                      getComponentUiText(
                        CustomExceptionsUIText[postDomains?.data?.error?.type],
                      );
                  }
                  // showError(postDomains?.data?.error?.message);
                  urlNotBelongToDomain.forEach((data) => {
                    currentListWebFacing.value =
                      currentListWebFacing.value.filter(
                        (item) =>
                          !item.url ||
                          getDomainFromUrl(item.url) !== data.domainName,
                      );
                  });
                }
              } catch (error: any) {
                dataPage[idPage.webFacingAppPage].statusPage = statusPage.Error;
                if (error) {
                  dataPage[idPage.webFacingAppPage].errorMessage =
                    getComponentUiText(
                      CustomExceptionsUIText[error?.data?.error?.type],
                    );
                }
                // showError(error?.data?.error?.message);
              }
            },
            "update:close": (isCancel) => {
              if (isCancel) {
                urlNotBelongToDomain.forEach((data) => {
                  if (data.id && oldValue) {
                    const oldValueItem = oldValue.find(
                      (el) => el.id === data.id,
                    );
                    currentListWebFacing.value[
                      currentListWebFacing.value.findIndex(
                        (el) => el.id === data.id,
                      )
                    ] = oldValueItem;
                  } else {
                    currentListWebFacing.value =
                      currentListWebFacing.value.filter(
                        (item) =>
                          !item.url ||
                          getDomainFromUrl(item.url) !== data.domainName,
                      );
                  }
                });
                store.commit("SetupWizard/SET_VALUES_WEBSERVICES", [
                  {
                    values: cloneDeep(currentListWebFacing.value),
                  },
                ]);
                directionActivePAge(activeDirection);
                hanldleSetupWebFacingCallAction(dataDeleteItem);
              } else {
                handleSectionsChange({
                  status: true,
                  namePage: WIZARD_STATE_PAGE.WEBSERVICES,
                  isSelectedPage: "isSelectedWebFacing",
                });
              }
            },
          },
        };
        EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      } else {
        directionActivePAge(activeDirection);
        hanldleSetupWebFacingCallAction(dataDeleteItem);
      }
    } else {
      directionActivePAge(activeDirection);
      hanldleSetupWebFacingCallAction(dataDeleteItem);
    }
  } catch (error: any) {
    if (error) {
      dataPage[idPage.webFacingAppPage].errorMessage = getComponentUiText(
        CustomExceptionsUIText[error?.data?.error?.type],
      );
    }
    // showErrorAPI(error, Org.postWebFacingSetup);
  } finally {
    isDeleteItemSuccess.value = false;
    if (!dataDeleteItem) {
      handleSectionsChange({
        status: false,
        namePage: WIZARD_STATE_PAGE.WEBSERVICES,
        isSelectedPage: "isSelectedWebFacing",
      });
    }
  }
};

const directionActivePAge = (direction) => {
  if (direction == null) return;
  if (direction === activeDirection.next) {
    activeComponent.value = idPage.sitesPage;
    return;
  }
  if (direction === activeDirection.prev) {
    activeComponent.value = idPage.servicesPage;
    return;
  }
  if (direction === activeDirection.save) {
    store.dispatch("SetupWizard/onModalSetupWizard", false);
    router.push({ path: "/" });
    return;
  }
  activeComponent.value = direction;
};

const handleIsSelected = (_activeComponent) => {
  if (_activeComponent === idPage.goalsPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.GOALS,
      isSelectedPage: "isSelectedGoals",
    });
  }
  if (_activeComponent === idPage.domainPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.DOMAINS,
      isSelectedPage: "isSelectedDomains",
    });
  }
  if (_activeComponent === idPage.brandsPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.BRANDS,
      isSelectedPage: "isSelectedBrands",
    });
  }
  if (_activeComponent === idPage.servicesPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.SERVICES,
      isSelectedPage: "isSelectedServices",
    });
  }
  if (_activeComponent === idPage.orgsPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.ORG,
      isSelectedPage: "isSelectedOrg",
    });
  }
  if (_activeComponent === idPage.teamsPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.TEAMS,
      isSelectedPage: "isSelectedTeams",
    });
  }
  if (_activeComponent === idPage.sitesPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.SITES,
      isSelectedPage: "isSelectedSites",
    });
  }
  if (_activeComponent === idPage.webFacingAppPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.WEBSERVICES,
      isSelectedPage: "isSelectedWebFacing",
    });
  }
  if (_activeComponent === idPage.miscellaneousPage) {
    handleSectionsChange({
      status: true,
      namePage: WIZARD_STATE_PAGE.MISC,
      isSelectedPage: "isSelectedMisc",
    });
  }
};
const handleSectionsChange = (value) => {
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    namePage: value.namePage,
    currentOrg: currentOrg.value.id,
    isSelected: value.status ? true : false,
    isSelectedPage: value.isSelectedPage,
  });
};

const openModalDeleteItem = (data) => {
  if (!data.item.id) {
    deleteItem(data, null);
    handleIsSelected(activeComponent.value);
    return;
  }
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_DELETE,
    properties: {
      title:
        getComponentUiText("app-settings-domain-verify-modal-delete-button-1") +
        " " +
        getTitlePageModalDelete(activeComponent.value) +
        " - " +
        getNameItem(data.item, activeComponent.value),
      description: getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-description-1",
        false,
        {
          pageName:
            getTitlePageModalDelete(activeComponent.value)?.toLowerCase() ?? "",
        },
      ),
      show: true,
      endDate: data.item?.endDate,
      idItem: data.item?.id,
      page:
        activeComponent.value === idPage.webFacingAppPage
          ? data.item.url
            ? WIZARD_STATE_PAGE.WEB
            : WIZARD_STATE_PAGE.WEBNAT
          : idWizardPageIdName[activeComponent.value],
    },
    events: {
      "update:data": (endDate: string) => updateEndDateItem(endDate, data),
      "delete:data": (res) => deleteItem(data, res),
      "delete:data:error": () => {
        dataPage[activeComponent.value].statusPage = statusPage.Error;
        if (activeComponent.value === idPage.webFacingAppPage) {
          dataPage[idPage.webFacingAppPage].dataError = [
            {
              id: data.item.id,
              isDelete: true,
              serviceTypeId: data.item.serviceTypeId,
            },
          ];
        } else if (activeComponent.value === idPage.brandsPage) {
          dataPage[idPage.brandsPage].dataError = [
            {
              id: data.item.id,
              isDelete: true,
            },
          ];
        } else {
          dataPage[activeComponent.value].dataError = [
            {
              id: data.item.id,
              isDelete: true,
            },
          ];
        }
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const updateEndDateItem = (endDate: string, data) => {
  const formattedDate = dayjs(endDate).locale(getLocale()).format("YYYY-MM-DD");
  let itemUpdate = {
    id: data.item?.id,
    endDate: formattedDate ?? null,
    updated: true,
  };
  let serviceUpdateItem;

  if (activeComponent.value === idPage.servicesPage) {
    if (!data.item?.id) {
      serviceUpdateItem = {
        ...itemUpdate,
        description: data.item?.description || null,
        name: data.item?.name || null,
        notes: data.item?.notes || null,
        serviceTypeId: data.item?.serviceTypeId,
        startDate: data.item?.startDate || null,
        indexUpdate: data.item?.indexUpdate,
        indexGroup: data.groupIndex,
        indexCurrent: data.currentIndex,
      };
      if (!data.item?.startDate) {
        delete serviceUpdateItem.startDate;
      }
    } else {
      serviceUpdateItem = {
        ...itemUpdate,
        indexUpdate: data.item?.indexUpdate,
        indexGroup: data.groupIndex,
        indexCurrent: data.currentIndex,
      };
    }
  }

  if (activeComponent.value === idPage.webFacingAppPage) {
    currentListWebFacing.value[data.index] = {
      ...currentListWebFacing.value[data.index],
      ...itemUpdate,
    };
  } else {
    const dataStore: IWizardUpdateQuestionItem = {
      item:
        activeComponent.value === idPage.servicesPage
          ? serviceUpdateItem
          : itemUpdate,
      index: data.item?.indexUpdate ?? data.index,
      type: "UPDATE",
      currentOrg: currentOrg.value.id,
      namePage: WIZARD_STATE_NAME_FROM_ID[activeComponent.value],
    };
    store.dispatch("SetupWizard/updateValuesItem", dataStore);
  }

  if (data.item.id) {
    isDeleteItemSuccess.value = true;
    store.commit(
      "SetupWizard/SET_INDEX_UPDATE_ITEM",
      data.item?.indexUpdate ? null : data.index,
    );
    handleCallApiPageSetup(activeComponent.value, {
      item:
        activeComponent.value === idPage.servicesPage
          ? serviceUpdateItem
          : data.item,
      type: "UPDATE",
      index: data.item?.indexUpdate ?? data.index,
      typeId: data.item?.typeId,
    });
  }
};

const deleteItem = (data, res) => {
  const itemUpdate = {
    id: data.item?.id,
    isArchived: true,
    updated: true,
    name: data.item?.name,
    idUpdate: data.item?.idUpdate,
  };

  if (activeComponent.value === idPage.webFacingAppPage) {
    if (data.item?.id) {
      currentListWebFacing.value[data.index] = {
        ...currentListWebFacing.value[data.index],
        ...itemUpdate,
      };
      webFacingRef.value?.onDeleteItem(data.index);
    } else {
      currentListWebFacing.value.splice(data.index, 1);
    }
  } else {
    const dataStore: IWizardUpdateQuestionItem = {
      item: itemUpdate,
      index: data.item?.indexUpdate ?? data.index,
      type: "DELETE",
      currentOrg: currentOrg.value.id,
      namePage: WIZARD_STATE_NAME_FROM_ID[activeComponent.value],
    };
    if (activeComponent.value === idPage.servicesPage) {
      dataStore.item.indexGroup = data.groupIndex;
      dataStore.item.indexCurrent = data.currentIndex;
      EventEmitter.emit(EmitterEvents.SERVICE_DELETE_ITEM, {
        indexGroup: data.groupIndex,
        indexCurrent: data.currentIndex,
        ...data.item,
      });
    }
    store.dispatch("SetupWizard/updateValuesItem", dataStore);
  }

  if (data.item?.id) {
    isDeleteItemSuccess.value = true;
    handleCallApiPageSetup(activeComponent.value, {
      item:
        activeComponent.value === idPage.servicesPage ? itemUpdate : data.item,
      type: "DELETE",
      index: data.item?.indexUpdate ?? data.index,
      typeId: data.item?.typeId,
      res,
    });
  }
};

const getTitlePageModalDelete = (activeComponentId) => {
  switch (activeComponentId) {
    case idPage.domainPage:
      return getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-title-domain-1",
      );
    case idPage.brandsPage:
      return getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-title-brand-1",
      );
    case idPage.servicesPage:
      return getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-title-service-1",
      );
    case idPage.webFacingAppPage:
      return getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-title-web-facing-1",
      );
    case idPage.sitesPage:
      return getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-title-site-1",
      );
    case idPage.teamsPage:
      return getComponentUiText(
        "app-wizards-setup-wizard-modal-delete-title-team-1",
      );
  }
};

const getMessageSuccessDeleteItem = (
  activeComponentId: number,
  dataItem: any,
) => {
  const itemName =
    getNameItem(dataItem?.item, activeComponentId) !== ""
      ? getNameItem(dataItem?.item, activeComponentId)
      : `${dataPage[activeComponentId].title} ${getComponentUiText(
          "app-wizards-setup-wizard-message-updated-item-1",
        )}`;

  return dataItem.type === "DELETE"
    ? getComponentUiText(
        "app-wizards-setup-wizard-message-deleted-item-success-1",
        false,
        {
          itemName,
        },
      )
    : getComponentUiText(
        "app-wizards-setup-wizard-message-updated-item-success-1",
        false,
        {
          itemName,
        },
      );
};

const currentUser: any = ref(null);
const getCurrentUserData = async () => {
  try {
    const currendUserData: any = await getCurrentUser();
    if (currendUserData.data?.data) {
      currentUser.value = currendUserData.data.data;
      localStorage.setItem(
        localStorageKey.currentUserData,
        JSON.stringify(currendUserData.data.data),
      );
    }
  } catch (error) {
    showErrorAPI(error, UserRoute.get);
  }
};

const getNameItem = (item, activeComponent) => {
  switch (activeComponent) {
    case idPage.domainPage:
      return item.domainName ?? "";
    case idPage.brandsPage:
      return item.brandName ?? "";
    case idPage.servicesPage:
      return item.name ?? "";
    case idPage.webFacingAppPage:
      return item.description ?? item.appName ?? "";
    case idPage.sitesPage:
      return item.name ?? "";
    case idPage.teamsPage:
      return item.details ?? "";
  }
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const showSuccessToast = (message: string) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message: message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const overflowVisibleComponents = [0];

const DomainData = {
  titleQuestion: getComponentUiText(
    "app-menu-submenu-home-setup-wizard-modal-domain-question-1",
  ),
  title: getComponentUiText(
    "app-menu-submenu-home-setup-wizard-modal-domain-title-1",
  ),
  description: getComponentUiText(
    "app-menu-submenu-home-setup-wizard-modal-domain-description-1",
  ),
};
const WebFacingAppData = {
  titleQuestion: getComponentUiText(
    "app-menu-submenu-home-setup-wizard-modal-webfacingapp-question-1",
  ),
  title: getComponentUiText(
    "app-menu-submenu-home-setup-wizard-modal-webfacingapp-title-1",
  ),
  description: getComponentUiText(
    "app-menu-submenu-home-setup-wizard-modal-webfacingapp-description-1",
  ),
};

const dataPage = reactive([
  {
    id: idPage.goalsPage,
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-goals-title-1",
    ),
    errorMessage: "",
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
  {
    id: idPage.orgsPage,
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-orgs-title-1",
    ),
    errorMessage: "",
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
  {
    id: idPage.domainPage,
    title: DomainData.title,
    errorMessage: "",
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
  {
    id: idPage.brandsPage,
    title: getComponentUiText(
      "app-component-wizards-setup-wizard-brands-page-title-1",
    ),
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
  {
    id: idPage.servicesPage,
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-services-title-1",
    ),
    statusPage: statusPage.NotChange,
    errorMessage: "",
    dataError: [] as any[],
  },
  {
    id: idPage.webFacingAppPage,
    title: WebFacingAppData.title,
    statusPage: statusPage.NotChange,
    errorMessage: "",
    dataError: [] as any[],
  },
  {
    id: idPage.sitesPage,
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-sites-title-1",
    ),
    errorMessage: "",
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
  {
    id: idPage.teamsPage,
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-teams-title-1",
    ),
    errorMessage: "",
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
  {
    id: idPage.miscellaneousPage,
    title: getComponentUiText(
      "app-component-wizards-setup-wizard-miscellaneous-page-title-1",
    ),
    errorMessage: "",
    statusPage: statusPage.NotChange,
    dataError: [] as any[],
  },
]);

onMounted(() => initial());

const onClickProgressIndictorItem = async (id: number) => {
  const isValid = await validateForm();
  if (!isValid) {
    return;
  }
  if (activeComponent.value !== idPage.webFacingAppPage) {
    activeComponent.value = id;
  }
  handleCallApiPageSetup(activeComponent.value, null, id);
};

const initial = async () => {
  await getCurrentUserData();
};
watch(
  () => props.showStateComponent,
  () => {
    if (props.showStateComponent === 0) {
      const queryValue = route.query?.type;
      switch (queryValue) {
        case WIZARD_STATE_NAME.DOMAINS:
          activeComponent.value = 2;
          break;
        case WIZARD_STATE_NAME.WEBSERVICES:
          activeComponent.value = 5;
          break;
        default:
          activeComponent.value = 0;
          break;
      }
    }
  },
);
</script>

<style lang="scss" scoped>
.wrapper-container {
  overflow: auto;
  // background: rgba(239, 240, 241, 0.5);

  .body-container {
    overflow: hidden;
    height: 100%;

    .container {
      padding: 0;
      border-radius: 6px;
    }
  }

  .slide-item {
    background: #ffffff;
    display: none;

    &.show {
      display: block;
    }

    &.fade {
      animation-name: fade;
      animation-duration: 1.5s;
    }
  }
}

@keyframes fade {
  from {
    opacity: 0.4;
  }

  to {
    opacity: 1;
  }
}

@media screen and (max-width: 767px) {
  .body-container {
    width: 100% !important;
  }

  .footer-container {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
